import {Routes} from "@angular/router";

import {CheminAccesRefuse, PageAccesRefuseComponent, PageSaisieParametresConnexionComponent, valApplicationAutoriseeGuard, valAuthetificationGuard, ValCallbackComponent} from "../../../../val-authentification-lib/src/public-api";
import {ApplicationsPlateforme} from "../../../../val-definitions-communes-lib/src/public-api";
import {VuePrincipaleComponent} from "./vue-principale/vue-principale.component";
import {VueDashboardComponent, VueFactureVentePageComponent, factureRoutes} from "../../../val-ammon-efact-lib/src/public-api";
import { VueFactureAchatPageComponent } from "../../../val-ammon-efact-lib/src/lib/vue-facture-achat-recherche/vue-facture-achat/vue-facture-achat-page/vue-facture-achat-page.component";
import {MesAbonnementsComponent, MesPreferencesComponent} from "../../../../val-ammon-composants/val-composants-lib/src/public-api";

//Garde d’autorisation de l’application, sur toutes les pages : une session déjà ouverte ou une
//URL directe ne repasse pas par le callback et doit être bloquée elle aussi (ADR-0017, D11).
const valApplicationEFactureGuard = valApplicationAutoriseeGuard (ApplicationsPlateforme.eFacture);

//Représente les routes de l’application
export const routes: Routes =
[
  {path: "", component: PageSaisieParametresConnexionComponent},
  {path: "callback", component: ValCallbackComponent},
  {path: CheminAccesRefuse, component: PageAccesRefuseComponent},
  {
    path: "main",
    component: VuePrincipaleComponent,
    canActivate: [valAuthetificationGuard, valApplicationEFactureGuard],
    children:
    [
      {path: "accueil", component: VueDashboardComponent, outlet: "page"},
      {path: "abonnements", component: MesAbonnementsComponent, outlet: "page"},
      {path: "preferences", component: MesPreferencesComponent, outlet: "page"},
      ...factureRoutes
    ]
  },
  {path: "vente/:id", component: VueFactureVentePageComponent, canActivate: [valAuthetificationGuard, valApplicationEFactureGuard]},
  {path: "achat/:id", component: VueFactureAchatPageComponent, canActivate: [valAuthetificationGuard, valApplicationEFactureGuard]}
];
